import React from 'react';
import { Size } from '../../Enums/Size.enum';
import { useTreatmentContext } from '../../Services/TreatmentContext';
import Modal from '../Modal/Modal';
import DeletePatient from './DeletePatient';

interface Props {
	patientId?: string;
	onClose: () => void;
	onPatientDelete: () => void;
	opened: boolean;
}

const DeletePatientModal: React.FC<Props> = props => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={props.opened}
			onClose={props.onClose}
			wrapChat={isCase}
			size={Size.MD}>
			<Modal.Header title={'component.patient.removeFromEArchive'} />
			<Modal.Content contentScroll>
				<DeletePatient {...props} />
			</Modal.Content>
		</Modal>
	);
};

export default DeletePatientModal;
